@if (!isNotConfigured) {
  <div>
    <form [formGroup]="carrierForm" class="mb-3">
      @if (displayEnrollModuleQuestions) {
        <div class="content-container mb-3">
          <div class="message-card w-100 mb-3">
            <mwp-text-translate text="Please answer the following:" jsonKey="carrierModuleNote" />
          </div>
          @for (enrollModuleQuestion of additionalModuleBase.enrollModuleQuestions; track enrollModuleQuestion; let i = $index) {
            <div class="mb-3" [formArrayName]="formArrayName">
              <div class="mb-1">
                {{enrollModuleQuestion.questionTitle}}
              </div>
              <mwp-button-toggle [form]="getFormGroup(i)" [nameForControl]="'questionResponse'" [dataEnum]="booleanEnum" [label]="enrollModuleQuestion.questionForDisplay" />
            </div>
          }
        </div>
      }
      @if (displayBenficaryPrimaryGrid) {
        <div class="message-card w-100 mb-3">
          <mwp-text-translate text="At least one primary beneficiary is required and maximum of two beneficiaries can be used as a primary for this benefit." jsonKey="carrierModuleNote2" />
        </div>
      }
      @if (displayBenficaryPrimaryGrid) {
        <div class="content-container table-comp standard-table-fix mb-3">
          <div class="title">
            <mwp-text-translate text="Beneficiaries" jsonKey="beneficiaries" />
          </div>
          <div class="content">
            <table>
              <thead>
                <tr>
                  <th style="width: 12%;"></th>
                  <th>
                    <mwp-text-translate text="First Name" jsonKey="firstName" />
                  </th>
                  <th>
                    <mwp-text-translate text="Last Name" jsonKey="lastName" />
                  </th>
                  <th>
                    <mwp-text-translate text="Relationship" jsonKey="relationship" />
                  </th>
                  <th style="width: 12%;">
                    <mwp-text-translate text="Percentage" jsonKey="percentage" />
                  </th>
                </tr>
              </thead>
              <tbody [formArrayName]="beneficiaryListArrayName">
                @for (item of gridBeneficiaryArrayControls; track item; let i = $index) {
                  <tr [formGroupName]="i">
                    <td>
                      {{getBeneficiaryHeaderName(item)}}
                    </td>
                    <td>
                      <mat-form-field appearance="outline">
                        <input matInput formControlName="firstName" (ngModelChange)="onChangeValidation(i)">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="outline">
                        <input matInput formControlName="lastName" (ngModelChange)="onChangeValidation(i)">
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="outline">
                        <mat-select id="relationship" name="relationship" formControlName="relationship">
                          @for (itemRelationship of relationshipsList; track itemRelationship) {
                            <mat-option [value]="itemRelationship.value"
                              (onSelectionChange)="onChangeValidation(i)">
                              {{itemRelationship.text}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field appearance="outline">
                        <input matInput formControlName="tempPercentage" type="number" [min]="0" [max]="100" [attr.min]="0" [attr.max]="100" (ngModelChange)="onChangeValidation(i)">
                      </mat-form-field>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </form>
    <div>
      <mwp-benefit-enrollment-wizard-control [isContinueDisabled]="carrierForm.invalid" (emitComplete)="submitComplete()" />
    </div>
  </div>
}
@if (isNotConfigured) {
  <mwp-wizard-error [errorPanelName]="panelName" />
}